import React from 'react';
import ReactMarkdown from 'react-markdown';

import ImageCarousel from 'component/ImageCarousel';
import FrameL, { Img } from 'component/FrameL';

import './style.css';
import RadarGallery from 'component/RadarGallery';

export default ({ cmsData }) => {
    const { HeroImage = [], Introduction, PressExcerpts, PromoVideo, NewBanner } = cmsData;
    return <stack-l class="xl:container mx-auto px-4 pb-10" space="var(--s5)" aria-label="Home Page" role="main">
        <div className="break-out-banner">
            <ImageCarousel ratio="21:9">
                {HeroImage.map((Image, i) => {
                    return <FrameL ratio="21:9" Image={Image} key={i}></FrameL>
                })}
            </ImageCarousel>
        </div>

        <div className="text-center max-w-screen-lg mx-auto">
            <stack-l>
                <h2 className="font-normal">A Cultivated Waterfront Escape</h2>
                <h1>Lookout Point Lakeside Inn</h1>
                <h3>THERE’S A BEGUILING RHYTHM TO DAYS IN HOT SPRINGS</h3>
                <h3>AT THE MOST ROMANTIC HOTEL IN AMERICA.</h3>
            </stack-l>
            <ReactMarkdown className="mt-8">{Introduction}</ReactMarkdown>
        </div>
        <RadarGallery cmsData={NewBanner} ></RadarGallery>
        <ReactMarkdown className="press-excerpts text-center">{PressExcerpts}</ReactMarkdown>

        <div className="break-out-banner">
            <Img className='w-full' Image={PromoVideo} isVideoAutoplay={true}></Img>
        </div>
    </stack-l>
}